export default __webpack_public_path__ + "static/media/01 Marketing - Floor Plan by Type 7.b148db50.jpeg";